import React, { Component } from "react";

import PropTypes from "prop-types";


export class Button1Item extends Component {
  
  static propTypes = {
    extra: PropTypes.object.isRequired,
  };
  
  render() {
      //@ts-ignore
    const { acf } = this.props.extra;
      return (
        <div className="around-button"><span className="myButton"><a className="button" href={acf.button_link_extra}>{acf.button_text_extra}</a></span></div>
      );
   
  }
}

export default Button1Item;
